// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/ontology/api/temporal.proto (package gx.ontology.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_temporal_ontology_project_sync } from "../../../temporal/ontology/project_sync_pb.js";

/**
 * Describes the file services/ontology/api/temporal.proto.
 */
export const file_services_ontology_api_temporal = /*@__PURE__*/
  fileDesc("CiRzZXJ2aWNlcy9vbnRvbG9neS9hcGkvdGVtcG9yYWwucHJvdG8SD2d4Lm9udG9sb2d5LmFwaSJyCilUcmlnZ2VyT250b2xvZ3lQcm9qZWN0U3luY1dvcmtmbG93UmVxdWVzdBJFCgVpbnB1dBgBIAEoCzI2Lmd4LnRlbXBvcmFsLm9udG9sb2d5Lk9udG9sb2d5UHJvamVjdFN5bmNXb3JrZmxvd0lucHV0IlcKKlRyaWdnZXJPbnRvbG9neVByb2plY3RTeW5jV29ya2Zsb3dSZXNwb25zZRITCgt3b3JrZmxvd19pZBgBIAEoCRIUCgxleGVjdXRpb25faWQYAiABKAkysQEKD1RlbXBvcmFsU2VydmljZRKdAQoiVHJpZ2dlck9udG9sb2d5UHJvamVjdFN5bmNXb3JrZmxvdxI6Lmd4Lm9udG9sb2d5LmFwaS5UcmlnZ2VyT250b2xvZ3lQcm9qZWN0U3luY1dvcmtmbG93UmVxdWVzdBo7Lmd4Lm9udG9sb2d5LmFwaS5UcmlnZ2VyT250b2xvZ3lQcm9qZWN0U3luY1dvcmtmbG93UmVzcG9uc2VCxQEKE2NvbS5neC5vbnRvbG9neS5hcGlCDVRlbXBvcmFsUHJvdG9QAVpBZ2l0aHViLmNvbS9nYWxheHktaW8vZ3gvc2hhcmVkL2dvL2NvbnRyYWN0cy9zZXJ2aWNlcy9vbnRvbG9neS9hcGmiAgNHT0GqAg9HeC5PbnRvbG9neS5BcGnKAg9HeFxPbnRvbG9neVxBcGniAhtHeFxPbnRvbG9neVxBcGlcR1BCTWV0YWRhdGHqAhFHeDo6T250b2xvZ3k6OkFwaWIGcHJvdG8z", [file_temporal_ontology_project_sync]);

/**
 * Describes the message gx.ontology.api.TriggerOntologyProjectSyncWorkflowRequest.
 * Use `create(TriggerOntologyProjectSyncWorkflowRequestSchema)` to create a new message.
 */
export const TriggerOntologyProjectSyncWorkflowRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_temporal, 0);

/**
 * Describes the message gx.ontology.api.TriggerOntologyProjectSyncWorkflowResponse.
 * Use `create(TriggerOntologyProjectSyncWorkflowResponseSchema)` to create a new message.
 */
export const TriggerOntologyProjectSyncWorkflowResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_temporal, 1);

/**
 * @generated from service gx.ontology.api.TemporalService
 */
export const TemporalService = /*@__PURE__*/
  serviceDesc(file_services_ontology_api_temporal, 0);

